const min4LengthRegex = '([0-9]{4})';
export default min4LengthRegex;